import { fmtMoney } from "@/lib/api";
import { bsMonthLabel } from "@/lib/nepali";
import { cn } from "@/lib/utils";

export const periodBS = (period) => (period ? bsMonthLabel(`${period}-15`) : "");

export function PayslipBreakdown({ p }) {
  const line = (l, v, opts = {}) => (
    <div key={l} className={cn("flex justify-between py-1.5 border-b border-dashed border-border text-sm", opts.strong && "font-semibold text-base border-solid py-2", opts.muted && "text-muted-foreground")}>
      <span>{l}</span><span className={cn("font-mono", opts.neg && "text-destructive")}>{opts.neg ? "−" : ""}{fmtMoney(Math.abs(v))}</span>
    </div>
  );
  if (!p.earnings?.length) {
    return <div className="mt-2">{line("Basic salary", p.basic)}{line("Allowances", p.allowances)}{line("Tax", p.tax, { neg: true })}{line("Deductions", p.deductions, { neg: true })}{line("Net pay", p.net, { strong: true })}</div>;
  }
  return (
    <div className="mt-2" data-testid="payslip-breakdown">
      <div className="eyebrow !text-muted-foreground mb-1">Earnings</div>
      {p.earnings.map((e) => line(e.name, e.amount))}
      <div className="eyebrow !text-muted-foreground mt-3 mb-1">Deductions</div>
      {p.deductions_detail.map((e) => line(e.name, e.amount, { neg: true }))}
      {line("Net pay", p.net, { strong: true })}
      {p.employer_contributions?.length > 0 && <div className="mt-3"><div className="eyebrow !text-muted-foreground mb-1">Employer contributions (not deducted)</div>{p.employer_contributions.map((e) => line(e.name, e.amount, { muted: true }))}</div>}
      {p.annual && <div className="mt-3 text-[11px] font-mono text-muted-foreground" data-testid="payslip-annual">{p.regime} · {p.scheme} · annual taxable {fmtMoney(p.annual.taxable)} · annual tax {fmtMoney(p.annual.tax)}{p.annual.rebate ? ` · rebate ${fmtMoney(p.annual.rebate)}` : ""}</div>}
    </div>
  );
}
